import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { DiscountVoucherListPage } from '@/features/discount-vouchers'

export const Route = createFileRoute(
  '/_authenticated/billing/discount-vouchers'
)({
  component: () => (
    <RequirePermission permission='discount_vouchers.read'>
      <DiscountVoucherListPage />
    </RequirePermission>
  ),
})
